// extracted by mini-css-extract-plugin
module.exports = {"gwCoverageWrapper":"HomeCoverageTable_gwCoverageWrapper__1Pvqg"};